import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./Style.css";
import useWindowSize from "../../utils/useWindowSize";
import { payoutregenratedData } from "./helper/payoutdatasample";
import PayoutManagmentListing from "./PayoutManagementListing/PayoutManagmentListing";
import { Button, Select, Modal, Table, message } from "antd";
import DopdownMenuWithMonth from "./DopdownMenuWithMonth";
import { connect } from "react-redux";
import Logout from "../../containers/Pages/Login/Logout";
import RegenerationHistory from "./RegenerationHistory";
import { GeneratePayoutFormonthAction, payoutListDataSuccess, submitReportForApprovalAction } from "../../redux/PayoutListByFY/Action";
import { payoutMissingMonthforGenReportSuccess } from "../../redux/PayoutMissingMonthforGenReport/action";
import { payoutRegenerateHistorySuccess } from "../../redux/PayoutRegenerateHistory/action";
import useSession from "../CustomLogout/useSession";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Input } from "antd";
import { regen_payout_V } from "../../redux/Url";



const PayoutManagement = (props) => {
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const [regenerateData, setRegeneratedData] = useState([]);
  const [missingMonthsGen, setMissingMonthsGen] = useState([]);
  const [missingMonthsReGen, setMissingMonthsReGen] = useState([]);
  const [payoutListData, setPayoutListData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [isFetchingMissingMonths, setIsFetchingMissingMonths] = useState(false);
  const [isLoadingReGenerate, setIsLoadingReGenerate] = useState(false);
  const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
  const [downloading, setDownloading] = useState(false);


  const handleSessionExpired = useSession();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    // Assuming FY starts in April
    return today.getMonth() >= 3
      ? { value: String(year), label: `${year}-${String(year + 1).slice(-2)}` }
      : { value: String(year - 1), label: `${year - 1}-${String(year).slice(-2)}` };
  };

  // Financial year state
  const [financialYear, setFinancialYear] = useState(getCurrentFinancialYear().value);

  const monthMap = {
    "JAN": "January",
    "FEB": "February",
    "MAR": "March",
    "APR": "April",
    "MAY": "May",
    "JUN": "June",
    "JUL": "July",
    "AUG": "August",
    "SEP": "September",
    "OCT": "October",
    "NOV": "November",
    "DEC": "December",
  };



  const generateFinancialYearOptions = (startYear = 2022) => {
    const today = new Date();
    const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    const options = [];
    for (let y = year; y >= startYear; y--) {
      options.push({
        value: String(y),
        label: `${y}-${String(y + 1).slice(-2)}`,
      });
    }
    return options;
  };

  // Pagination state
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Fetch payout list with pagination
  const fetchPayoutList = async (page = 1, pageSize = 10, fy = financialYear) => {
    setDownloading(true);
    try {
      const payoutList = props.payoutListByFY({
        accessToken: props.accessToken,
        financialYear: fy,
        approvalstageId: 1,
        // page: page - 1, // backend might be 0-indexed
        // record: pageSize,
      });

      const payoutListresponse = await payoutList;
      const errorCode = payoutListresponse?.response?.data?.error?.errorCode || payoutListresponse.errorCode;
      const errorMessage = payoutListresponse?.response?.data?.error?.message || payoutListresponse.message;
      if (errorCode === "403" && (payoutListresponse?.data?.error?.logoutStatus || payoutListresponse?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        return; // Stop further execution
      }

      setPayoutListData(payoutListresponse || []);
      // setPagination((prev) => ({
      //   ...prev,
      //   current: page,
      //   pageSize,
      //   total: payoutListresponse?.totalPages || 0,
      // }));
    } catch (error) {
      console.error("Error fetching payout list:", error);
    } finally {
      setDownloading(false);
    }
  };



  const fetchMissingMonthsForGenReport = async () => {
    console.log("debug generate report")
    if (isFetchingMissingMonths) return; // Prevent double clicks
    setIsFetchingMissingMonths(true);
    try {
      const missingMonths = props.payoutMissingMonthforGenReport({
        accessToken: props.accessToken,
        financialYear: financialYear,
      });
      const missingMonthsResponse = await missingMonths;
      const errorCode = missingMonthsResponse?.response?.data?.error?.errorCode || missingMonthsResponse.errorCode;
      const errorMessage = missingMonthsResponse?.response?.data?.error?.message || missingMonthsResponse.message;
      if (errorCode === "403" && (missingMonthsResponse?.data?.error?.logoutStatus || missingMonthsResponse?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        setIsFetchingMissingMonths(false);
        return; // Stop further execution
      }

      // Update state with the fetched data
      setMissingMonthsGen(missingMonthsResponse?.months_missing || []);

      // Filter and map the months for regeneration report
      const regenMonth = Object.entries(missingMonthsResponse?.months_done || {})
        .filter(([month, arr]) => Array.isArray(arr) && arr[0]?.version <= parseInt(regen_payout_V)) // regenerate version limit
        .map(([month]) => month);
      setMissingMonthsReGen(regenMonth || []);

      if(payoutListData.length ===0){
         await fetchPayoutList(pagination.current, pagination.pageSize, financialYear); // Refresh payout list
      }
     
    } catch (error) {
      console.error("Error fetching missing months for generation report:", error);
    } finally {
      setIsFetchingMissingMonths(false);
    }
  };


  const fetchRegenerateHistory = async (page = 1, pageSize = 10) => {
    try {
      const regenerateHistory = props.payoutRegenerateHistory({
        accessToken: props.accessToken,
        financialYear: financialYear,
        page: page - 1, // backend might be 0-indexed
        record: pageSize,

      });
      const regenerateHistoryResponse = await regenerateHistory;

      const errorCode = regenerateHistory?.response?.data?.error?.errorCode || regenerateHistory.errorCode;
      const errorMessage = regenerateHistory?.response?.data?.error?.message || regenerateHistory.errorMessage;
      if (errorCode === "403" && (regenerateHistory?.data?.error?.logoutStatus || regenerateHistory?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        return; // Stop further execution
      }
      setRegeneratedData(regenerateHistoryResponse.content || []);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: regenerateHistoryResponse?.totalElements || 0,
      }));
    } catch (error) {
      console.error("Error fetching regenerate history:", error);
    }
  };


  useEffect(() => {
    const fetchAllData = async () => {
      await Promise.all([
        fetchPayoutList(pagination.current, pagination.pageSize, financialYear),
        fetchMissingMonthsForGenReport(),
        fetchRegenerateHistory(pagination.current, pagination.pageSize)
      ]);
      // You can log here if needed
    };
    fetchAllData();
    // eslint-disable-next-line
  }, [financialYear]);

  const enabledMonths = Array.isArray(missingMonthsGen) ?
    missingMonthsGen.map(m => {
      const [mon] = m.split("-");
      return monthMap[mon] || mon;
    }) : [];

  const enabledMonthsreGen = Array.isArray(missingMonthsReGen) ?
    missingMonthsReGen.map(m => {
      const [mon] = m.split("-");
      return monthMap[mon] || mon;
    }) : [];

  // Handler for pagination change
  const handleTableChange = (pagination) => {
    fetchPayoutList(pagination.current, pagination.pageSize);
  };




  const handleGenerateReport = async (selectedMonth) => {
    if (generatingReport) return; // Prevent double click
    setGeneratingReport(true);

    let financialYear2 = financialYear; // Use the current financial year state
    const monthNumberMap = {
      "January": 1,
      "February": 2,
      "March": 3,
      "April": 4,
      "May": 5,
      "June": 6,
      "July": 7,
      "August": 8,
      "September": 9,
      "October": 10,
      "November": 11,
      "December": 12,
    };
    const monthNumber = monthNumberMap[selectedMonth] || selectedMonth;

    if (monthNumber <= 3) {
      // If month is January, February, or March, adjust financial year to add 1
      financialYear2 = String(Number(financialYear) + 1);
    }
    try {
      const genReport = props.GeneratePayoutFormonthAction({
        accessToken: props.accessToken,
        financialYear: financialYear2,
        month: monthNumber,
      });

      const genReportResponse = await genReport;


      const errorCode = genReportResponse?.response?.data?.error?.errorCode || genReportResponse.errorCode;
      if (errorCode === "403" && (genReportResponse?.data?.error?.logoutStatus || genReportResponse?.response?.data?.error?.logoutStatus)) {
        handleSessionExpired();
        return; // Stop further execution
      }

      if (
        !genReportResponse ||
        genReportResponse.response?.error ||
        genReportResponse.response?.success === false ||
        genReportResponse.response?.data?.data?.status === 500
      ) {
        let backendError =
          genReportResponse?.error?.message ||
          genReportResponse?.response?.data?.data?.errorMessage ||
          genReportResponse?.message ||
          "Failed to generate payout";

        backendError = backendError.replace(/^java\.lang\.RuntimeException:\s*/, "");
        message.error(backendError);
        return; // Stop here, do not show success message
      }
      // Refresh payout list after generating payout
      fetchPayoutList(pagination.current, pagination.pageSize, financialYear);
      fetchMissingMonthsForGenReport();
      fetchRegenerateHistory(pagination.current, pagination.pageSize);
      setIsLoadingGenerate(false);
      setIsLoadingReGenerate(false);
      message.success(`Payout generated for ${selectedMonth} ${financialYear2}`);

    } catch (error) {
      console.error("Error generating payout for month:", error);
      message.error("Failed to generate payout for the selected month. Please try again.");
    } finally {
      setGeneratingReport(false);
      setIsLoadingReGenerate(false);
    }
  };






  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const handleRegenerateHistory = () => {
    // setRegeneratedData(payoutregenratedData);
    setIsModalOpen(true);
  };



  // const handelSubmitForApproval = async (reportid) => {
  //   let remark = "";
  //   Modal.confirm({
  //     title: "Enter Remark For Approval",
  //     content: (
  //       <Input.TextArea
  //         placeholder="Please enter your remark"
  //         onChange={e => {
  //           remark = e.target.value;
  //         }}
  //         autoSize={{ minRows: 3, maxRows: 5 }}
  //       />
  //     ),
  //     okText: "Submit",
  //     cancelText: "Cancel",
  //      okButtonProps: {
  //     style: { backgroundColor: "#1b8593", borderColor: "#1b8593" } 
  //   },
  //     onOk: async () => {
  //       if (!remark.trim()) {
  //         message.error("Remark is required.");
  //         return Promise.reject();
  //       }
  //       try {
  //         const submitReport = props.submitReportForApproval({
  //           accessToken: props.accessToken,
  //           reportid: reportid,
  //           approvalStageId: 2,
  //           remarksComment: remark,
  //           remarkType: "Partner"
  //         });
  //         const submitReportResponse = await submitReport;

  //         const errorCode =
  //           submitReportResponse?.response?.data?.error?.errorCode ||
  //           submitReportResponse?.response?.status;

  //         if (
  //           errorCode === "403" &&
  //           (submitReportResponse?.response?.data?.error?.errorCode ||
  //             submitReportResponse?.response?.status)
  //         ) {
  //           console.log("Session expired, redirecting to login...");
  //           handleSessionExpired();
  //           return;
  //         }

  //         console.log("Submit Report Response:", submitReportResponse);
  //         if (!submitReportResponse || submitReportResponse.error) {
  //           message.error(
  //             submitReportResponse?.error || "Failed to submit report for approval"
  //           );
  //           return;
  //         }
  //         // Refresh payout list after submitting report
  //         fetchPayoutList(pagination.current, pagination.pageSize, financialYear);
  //         fetchMissingMonthsForGenReport();
  //         message.success("Report submitted for approval successfully.");
  //       } catch (error) {
  //         console.error("Error submitting report for approval:", error);
  //         message.error("Error submitting report for approval.");
  //       }
  //     },
  //   });
  // };
  const handelSubmitForApproval = async (reportid) => {
    let remark = "";
    Modal.confirm({
      title: "Enter Remark For Approval",
      content: (
        <Input.TextArea
          placeholder="Please enter your remark"
          // maxLength={250}
          onChange={e => {
            remark = e.target.value;
          }}
          autoSize={{ minRows: 3, maxRows: 5 }}
          maxLength={250} // Limit to 250 characters
          showCount={true} // Show character count
        />
      ),
      okText: "Submit",
      cancelText: "Cancel",
      okButtonProps: {
        style: { backgroundColor: "#1b8593", borderColor: "#1b8593" }
      },
      onOk: async () => {
        if (remark === "") {
          message.error("Remark is required.");
          return 0;
        }
        if (remark.length > 250) {
          message.error("Remark should not exceed 250 characters.");
          return 0;
        }
        try {
          const submitReport = props.submitReportForApproval({
            accessToken: props.accessToken,
            reportid: reportid,
            approvalStageId: 2,
            remarksComment: remark,
            remarkType: "Partner"
          });
          const submitReportResponse = await submitReport;

          const errorCode =
            submitReportResponse?.response?.data?.error?.errorCode ||
            submitReportResponse?.response?.status;

          if (
            errorCode === "403" &&
            (submitReportResponse?.response?.data?.error?.errorCode ||
              submitReportResponse?.response?.status)
          ) {
            handleSessionExpired();
            return;
          }
          if (!submitReportResponse || submitReportResponse.error) {
            message.error(
              submitReportResponse?.error || "Failed to submit report for approval"
            );
            return;
          }
          // Refresh payout list after submitting report
          fetchPayoutList(pagination.current, pagination.pageSize, financialYear);
          fetchMissingMonthsForGenReport();
          message.success("Report submitted for approval successfully.");
        } catch (error) {
          console.error("Error submitting report for approval:", error);
          message.error("Error submitting report for approval.");
        }
      },
    });
  };

  return (
    <div style={{ maxWidth: "100%" }}>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            {/* <Button
              type="default"
              style={{ margin: "16px 0" , border: 'none', }}
              onClick={() => navigate(-1)}
            >
              &#8592;
            </Button> */}
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ display: "flex" }}>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col
              md={6}
              style={{ display: "flex", margin: 10 }}
              className="btn-partner"
            >
              {/* <div>
                <Select
                  style={{ width: 150 }}
                  showSearch
                  placeholder="Select financial Year"
                  optionFilterProp="label"
                  value={financialYear}
                  onChange={(value) => setFinancialYear(value)}
                  options={generateFinancialYearOptions(2022)}
                />
              </div> */}
            </Col>
          </Col>
        </div>
      </Row>

      <Row style={{ display: "flex" }}>
        <Col md={3}>
          <div>
            <Select
              style={{
                width: 150,
                marginTop: width < 750 ? 70 : 10,
              }}
              showSearch
              placeholder="Select financial Year"
              optionFilterProp="label"
              value={financialYear}
              onChange={(value) => setFinancialYear(value)}
              options={generateFinancialYearOptions(2022)}
            />
          </div>
        </Col>
        <Col
          md={9}
          style={{
            display: "flex",
            justifyItems: "end",
            alignItems: "end",
            justifyContent: "end",
          }}
          className="btn-partner"
        >
          <DopdownMenuWithMonth
            lastGeneratedMonths={enabledMonths}
            name={"Generate Report"}
            onSelectMonth={handleGenerateReport}
            isLoadingGenerate={isLoadingGenerate}
            setIsLoadingGenerate={setIsLoadingGenerate}
          />

          <DopdownMenuWithMonth
            lastGeneratedMonths={enabledMonthsreGen}
            name={"Regenerate Report"}
            onSelectMonth={handleGenerateReport}
            isLoadingGenerate={isLoadingReGenerate}
            setIsLoadingGenerate={setIsLoadingReGenerate}
          />

          <Button
            className="btn-regenerate"
            type="primary"
            style={{
              width: 170,
              margin: 5,
              backgroundColor: "#1b8593",
              color: "white",
              fontSize: "0.8rem",
              justifyContent: "center",
              overflow: "hidden",
              padding: 10,
              border: "none",
              borderRadius: 5,
            }}
            onClick={() => handleRegenerateHistory()}
          >
            Regeneration History
          </Button>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <PayoutManagmentListing
            dataSource={payoutListData}
            pagination={pagination}
            onChange={handleTableChange}
            loading={props.loading}
            handelSubmit={handelSubmitForApproval}
            downloading={downloading}
          />
        </Col>
      </Row>

      <RegenerationHistory
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        regenerateData={regenerateData}
        setRegeneratedData={setRegeneratedData}
        pagination={pagination}
        setPagination={setPagination}
        onChange={handleTableChange}
      />

      {/* 
        <div>PayoutManagement</div> */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    payoutListByFY: (data) => dispatch(payoutListDataSuccess(data)),

    payoutMissingMonthforGenReport: (data) =>
      dispatch(payoutMissingMonthforGenReportSuccess(data)),

    GeneratePayoutFormonthAction: (data) =>
      dispatch(GeneratePayoutFormonthAction(data)),

    payoutRegenerateHistory: (data) => dispatch(payoutRegenerateHistorySuccess(data)),

    submitReportForApproval: (data) =>
      dispatch(submitReportForApprovalAction(data)),
  };

};

const mapStateToProps = (state) => {
  return {
    payoutListDataSuccess: state.payoutListByFY.payoutListByFY,
    loading: state.payoutListByFY.loading,
    payoutMissingMonthforGenReport: state.payoutMissingMonthforGenReport.payoutMissingMonthForGenReport,
    payoutMissingMonthForGenReportLoading: state.payoutMissingMonthforGenReport.loading,
    payoutRegenerateHistory: state.payoutRegenerateHistory.payoutRegenerateHistory,
    payoutRegenerateHistoryLoading: state.payoutRegenerateHistory.loading,
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PayoutManagement);
